import React, { useEffect, useState } from 'react';
import { TextField, Button, Grid, Paper, Typography, Autocomplete, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Checkbox, IconButton, Chip } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import 'dayjs/locale/en-gb';
import api from '../../api/api';
import { useNavigate } from 'react-router-dom';

export default function ExpenseRequestForm() {

  const navigate = useNavigate();

  const { user, token } = useAuth();

  const [managers, setManagers] = useState([]);

  const [expenseTypes, setExpenseTypes] = useState([]);

  const [formValues, setFormValues] = useState({
    empId: '',
    empName: '',
    visitingPlace: '',
    visitDays: '',
    purposeOfVisit: '',
    numberOfPersons: '',
    remark: '',
    approvalManager: ''
  });

  const [expenses, setExpenses] = useState([{ expenseType: -1, amount: 0, isBillAvailable: false }]);

  useEffect(() => {

    api.get('/api/Users/get_managers')
      .then(response => {
        setManagers(response.data);
      })
      .catch(error => {
        console.error('Error fetching managers', error);
      });

    setExpenseTypes([{ id: 0, name: 'Food' }, { id: 1, name: 'LocalTravel' }, { id: 2, name: 'Beverages' }]);

  }, []);

  const [files, setFiles] = useState([]);

  const handleFileChange = (event) => {
    const newFiles = Array.from(event.target.files);
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleDeleteFile = (fileName) => {
    setFiles((prevFiles) => prevFiles.filter(file => file.name !== fileName));
  };

  const getFileIcon = (file) => {
    const extension = file.name.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return <PictureAsPdfIcon />;
      case 'jpg':
      case 'jpeg':
      case 'png':
        return <ImageIcon />;
      case 'xls':
      case 'xlsx':
        return <InsertDriveFileIcon />;
      case 'doc':
      case 'docx':
        return <InsertDriveFileIcon />;
      default:
        return <AttachFileIcon />;
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (user) {
      const tempValues = { ...formValues }
      tempValues.empId = user.employee_code
      tempValues.empName = user['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name']
      setFormValues(tempValues)
    }
  }, [user]);

  const handleExpenseChange = (index, event) => {
    const { name, value, type, checked } = event.target;

    // For checkbox, use the 'checked' property instead of 'value'
    const newValue = type === 'checkbox' ? checked : value;

    console.log(`${name} | ${newValue}`);

    const newExpenses = [...expenses];
    newExpenses[index][name] = newValue;
    setExpenses(newExpenses);
  };

  const addExpenseRow = () => {
    setExpenses([...expenses, { expenseType: -1, amount: 0, isBillAvailable: false }]);
  };

  const deleteExpenseRow = (index) => {
    if (expenses.length > 1) {
      const newExpenses = expenses.filter((_, i) => i !== index);
      setExpenses(newExpenses);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('employeeId', user["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]);
    formData.append('visitingPlace', formValues.visitingPlace);
    formData.append('visitDays', formValues.visitDays);
    formData.append('purposeOfVisit', formValues.purposeOfVisit);
    formData.append('noOfPerson', formValues.numberOfPersons);
    formData.append('remarks', formValues.remark);
    formData.append('approvalManagerId', formValues.approvalManager);

    expenses.forEach((expense, index) => {
      formData.append(`expenses[${index}][expenseType]`, expense.expenseType);
      formData.append(`expenses[${index}][amount]`, expense.amount);
      formData.append(`expenses[${index}][isBillAvailable]`, expense.isBillAvailable);
    });

    formData.append(`expenses[${expenses.length}][expenseType]`, 3);
    formData.append(`expenses[${expenses.length}][amount]`, Math.floor(expenses.reduce((sum, expense) => sum + new Number(expense.amount), 0) * 0.1).toFixed(2));
    formData.append(`expenses[${expenses.length}][isBillAvailable]`, false);

    // formData.append('expenses', JSON.stringify(expenses));

    files.forEach((file, index) => {
      formData.append(`files`, file);
    });

    api.post('/api/ExpenseRequests', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(response => {
        navigate('/expense-request')
      })
      .catch(error => {
        console.error('Error submitting request', error);
        // Handle error
      });
  };

  return (
    <Paper
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 1200,
        margin: 'auto'
      }}
    >
      <Typography marginBottom={2} component="p" variant="h5">New Expense Request</Typography>
      <form sx={{ top: 200 }} onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Emp. ID"
              name="empId"
              value={formValues.empId}
              InputProps={{ readOnly: true }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Emp Name"
              name="empName"
              value={formValues.empName}
              InputProps={{ readOnly: true }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Visiting Place"
              name="visitingPlace"
              value={formValues.visitingPlace}
              onChange={handleInputChange}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Visit Days"
              name="visitDays"
              type="number"
              inputProps={{ min: 1 }}
              value={formValues.visitDays}
              onWheel={(e) => e.target.blur()}
              onChange={handleInputChange}
              required
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Purpose of Visit"
              name="purposeOfVisit"
              value={formValues.purposeOfVisit}
              onChange={handleInputChange}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="No. of Persons"
              name="numberOfPersons"
              type="number"
              inputProps={{ min: 1 }}
              value={formValues.numberOfPersons}
              onWheel={(e) => e.target.blur()}
              onChange={handleInputChange}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              disablePortal
              options={managers}
              getOptionLabel={(manager) => manager.name}
              getOptionKey={(manager) => manager.id}
              onChange={(event, value) => setFormValues((prevValues) => ({
                ...prevValues,
                approvalManager: value?.id || ''
              }))}
              value={managers.find(manager => manager.id === formValues.approvalManager) || null}
              sx={{ width: '100%' }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Approval Manager"
                  required
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Remark"
              name="remark"
              value={formValues.remark}
              onChange={handleInputChange}
              required
              fullWidth
            />
          </Grid>

          {/* <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Submit
            </Button>
          </Grid> */}
        </Grid>

        <Typography variant="h6" marginTop={4}>
          Expense Detail
        </Typography>
        <TableContainer component={Paper} sx={{ marginTop: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Expense Type *</TableCell>
                <TableCell align="center">Amount *</TableCell>
                <TableCell align="center">Is Bill Available?</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {expenses.map((expense, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Autocomplete
                      disablePortal
                      name='expenseType'
                      options={expenseTypes}
                      getOptionLabel={(expenseType) => expenseType.name}
                      getOptionKey={(expenseType) => expenseType.id}
                      onChange={(event, value) => {
                        const newExpenses = [...expenses];
                        newExpenses[index]['expenseType'] = value?.id ?? null;
                        setExpenses(newExpenses);
                        console.log(newExpenses);
                      }
                      }
                      value={expenseTypes.find(expenseType => expenseType.id == expense.expenseType) || null}
                      sx={{ width: '100%' }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                        />
                      )}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      name="amount"
                      type="number"
                      value={expense.amount}
                      inputProps={{ min: 1 }}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => handleExpenseChange(index, e)}
                      fullWidth
                      required
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Checkbox
                      name="isBillAvailable"
                      value={expense.isBillAvailable}
                      onChange={(e) => handleExpenseChange(index, e)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="secondary"
                      onClick={() => deleteExpenseRow(index)}
                      disabled={expenses.length === 1}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              <TableRow key={-1}>
                <TableCell>
                  <TextField
                    name="expenseType"
                    value='Incidental'
                    fullWidth
                    disabled={true}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    name="amount"
                    type="number"
                    value={Math.floor(expenses.reduce((sum, expense) => sum + new Number(expense.amount), 0) * 0.1).toFixed(2)}
                    fullWidth
                    disabled={true}
                  />
                </TableCell>
                <TableCell align="center">
                </TableCell>
                <TableCell align="center">
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Button onClick={addExpenseRow} >Add Another Expense</Button>
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableBody>
            <TableHead>
              <TableRow>
                <TableCell align="center">Total</TableCell>
                <TableCell align="center">{Math.floor(expenses.reduce((sum, expense) => sum + new Number(expense.amount), 0) * 1.1).toFixed(2)}</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>

        <Typography variant="h6" mt={4}>
          Upload Supporting Documents
        </Typography>
        <Grid container spacing={2} sx={{ my: 2 }}>
          {files.map((file, index) => (
            <Grid item key={index}>
              <Chip
                icon={getFileIcon(file)}
                label={file.name}
                onDelete={() => handleDeleteFile(file.name)}
                deleteIcon={<CloseIcon />}
              />
            </Grid>
          ))}
        </Grid>

        <Button
          variant="text"
          component="label"
        >
          Add Files
          <input
            type="file"
            accept=".jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.csv,.pdf"
            hidden
            multiple
            onChange={handleFileChange}
          />
        </Button>

        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ marginTop: 4 }}>
          Submit
        </Button>
      </form>
    </Paper>
  );
}
